var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99935 1.66602C6.78769 1.66602 4.16602 4.28768 4.16602 7.49935V8.59518C4.16602 9.18268 3.99102 9.75768 3.66602 10.2493L2.85852 11.4577C2.13352 12.5418 2.69185 14.0535 3.94185 14.394C4.94852 14.6743 5.96185 14.8868 6.98352 15.0327C7.05352 15.7244 7.34602 16.3744 7.84852 16.8852C8.41352 17.4544 9.18768 17.7702 9.99935 17.7702C10.811 17.7702 11.5852 17.4544 12.1502 16.8852C12.6527 16.3744 12.9452 15.7244 13.0152 15.0327C14.0368 14.8868 15.0502 14.6743 16.0568 14.394C17.3068 14.0535 17.8652 12.5418 17.1402 11.4577L16.3327 10.2493C16.0077 9.75768 15.8327 9.18268 15.8327 8.59518V7.49935C15.8327 4.28768 13.211 1.66602 9.99935 1.66602Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.61fc15eee89abbd3cbdc8b2630e9e86f.svg";
export { ForwardRef as ReactComponent };